import { useState } from 'react';
import Chip from '../Chip/Chip';
import type { FormControlAriaProps } from '../Form/FormField';

interface TagInputProps extends FormControlAriaProps {
    id: string;
    values: string[];
    onChange: (values: string[]) => void;
    placeholder?: string;
    disabled?: boolean;
}

const TagInput = ({ id, values, onChange, placeholder, disabled = false, ...ariaProps }: TagInputProps) => {
    const [text, setText] = useState('');

    const add = () => {
        const value = text.trim();
        if (value.length > 0 && !values.includes(value)) onChange([...values, value]);
        setText('');
    };

    return (
        <>
            <input
                id={id}
                type="text"
                className="form-control"
                placeholder={placeholder}
                disabled={disabled}
                value={text}
                onChange={(e) => setText(e.target.value)}
                onBlur={add}
                onKeyDown={(e) => {
                    if (e.key !== 'Enter') return;
                    e.preventDefault();
                    add();
                }}
                {...ariaProps}
            />
            {values.length > 0 && (
                <div className="d-flex flex-wrap gap-4 mt-8">
                    {/* by position, since values loaded from elsewhere can repeat and removing one copy must not remove the others */}
                    {values.map((value, index) => (
                        <Chip key={`${index}-${value}`} label={value} onRemove={disabled ? undefined : () => onChange(values.filter((_, other) => other !== index))} />
                    ))}
                </div>
            )}
        </>
    );
};

export default TagInput;
